<div class="iris-textarea-animation-container" #animationContainer>
  <textarea
    [attr.aria-describedby]="formControlName
      && (control.touched | isControlInvalidAndTouched:control.invalid)
        ? formControlName + '-error-messages' : null"
    [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
    [attr.required]="(control | isControlRequired) || null"
    [class]="textareaClasses"
    [formControl]="control"
    [id]="formControlName"
    (input)="autoResize()"
    [name]="formControlName"
    [ngClass]="{'invalid': control.touched | isControlInvalidAndTouched:control.invalid}"
    [placeholder]="placeholder"
    [readonly]="isReadonly"
    #textarea
  ></textarea>
<ng-content class="icon" *ngIf="hasIcon"></ng-content>
  <div *ngIf="maxCharacterCount" class="character-count-container">
    <div 
      class="character-count"
      [ngClass]="{'invalid': control.touched | isControlInvalidAndTouched:control.invalid}"
      aria-live="polite"
    >
      {{ currentCount$ | async }}/{{ maxCharacterCount }}
    </div>
  </div>
</div>
